import { createContext, useCallback, useContext, useState, type FC } from 'react';

type OrderToOpen = {
  batchEntryRank?: number;
  orderId: string;
};

type OpenOrderContextType = {
  clearOrderToOpen: () => void;
  orderToOpen?: OrderToOpen;
  setOrderToOpen: (orderToOpen: OrderToOpen) => void;
};

export const OpenOrderContext = createContext<OpenOrderContextType | null>(null);

export const OpenOrderContextProvider: FC = ({ children }) => {
  const [orderToOpen, setOrderToOpen] = useState<OrderToOpen>();
  const clearOrderToOpen = useCallback(() => setOrderToOpen(undefined), []);

  return (
    <OpenOrderContext.Provider
      value={{
        clearOrderToOpen,
        orderToOpen,
        setOrderToOpen,
      }}
    >
      {children}
    </OpenOrderContext.Provider>
  );
};

export const useOpenOrderContext = (): OpenOrderContextType => {
  const context = useContext(OpenOrderContext);

  if (!context)
    throw new Error('useOpenOrderContext must be used within a OpenOrderContextProvider');

  return context;
};
